import { put, select, takeLatest } from 'redux-saga/effects'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getBodySurveyOptionsSelector } from '../../options/selectors'
import { getFilteredOptions } from '../../../utilities/bodySurvey.util'
import {
  setBodySurveyBodyPartsOptions,
  setBodySurveyCardiacOptions,
  setBodySurveyGeneralExtremitiesOptions,
  setBodySurveySkinOptions,
} from '../../options/store/options.actions'
import { IBodySurveyOptions } from '../../options/store/options.types'
import { HomeConstants } from '../../home/store/home.constants'
import { BodyAssessmentConstants } from '../bodyAssessment/store/bodyAssessment.constants'

export function* setSelectedExamOptions() {
  const examOptions: IBodySurveyOptions = yield select(getBodySurveyOptionsSelector)
  const { examValueOptions } = examOptions

  try {
    const bodyPartsOptions = getFilteredOptions(BodyAssessmentConstants.BODY_PARTS, examValueOptions)
    const generalExtremitiesOptions = getFilteredOptions(BodyAssessmentConstants.GENERAL_EXTREMITIES, examValueOptions)
    const skinOptions = getFilteredOptions(BodyAssessmentConstants.EXTERNAL_SKIN, examValueOptions)
    const cardiacExamOptions = getFilteredOptions(BodyAssessmentConstants.CARDIO_CONDITIONS, examValueOptions)

    yield put(setBodySurveyBodyPartsOptions(bodyPartsOptions))
    yield put(setBodySurveyGeneralExtremitiesOptions(generalExtremitiesOptions))
    yield put(setBodySurveySkinOptions(skinOptions))
    yield put(setBodySurveyCardiacOptions(cardiacExamOptions))
  } catch (e) {
    yield put(throwPcrException(`setSelectedExamOptions() error: ${e}`))
  }
}

export function* setSelectedExamOptionsSaga() {
  yield takeLatest([HomeConstants.SET_NEW_PCR], performWithMutexHOG, setSelectedExamOptions)
}
